import React from 'react';

// Rope corner assets
const ROPE_LEFT = 'https://santaplaya-bucket.s3.amazonaws.com/rope1.webp';
const ROPE_RIGHT = 'https://santaplaya-bucket.s3.amazonaws.com/rope2.webp';

interface RopeQuoteProps {
  imageUrl: string; // Circle image
  title: string; // Title text
  body: string; // Body text
  imageOnLeft?: boolean; // Whether the image is on the left side (default true)
}

const RopeQuote: React.FC<RopeQuoteProps> = ({
  imageUrl,
  title,
  body,
  imageOnLeft = true,
}) => {
  return (
    <div
      className={`
        max-w-8xl 
        mx-auto 
        px-8 
        py-8 
        flex 
        flex-col 
        md:flex-row 
        items-center
        ${imageOnLeft ? '' : 'md:flex-row-reverse'}
      `}
    >
      {/* IMAGE CONTAINER */}
      <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
        {/* 
          Make the image a large circle using a square dimension.
          We also add a max size so it doesn't exceed 600px.
        */}
        <div
          className="
            relative
            w-[80vw]
            h-[80vw]
            md:w-[40vw]
            md:h-[40vw]
            max-w-[600px]
            max-h-[600px]
            overflow-hidden
            rounded-full
          "
        >
          <img
            src={imageUrl}
            alt={title}
            className="
              w-full
              h-full
              object-cover
            "
          />
        </div>
      </div>

      {/* TEXT (TITLE + BODY) */}
      <div
        className="
          w-full 
          md:w-1/2 
          flex 
          flex-col 
          items-center 
          justify-center 
          text-center
        "
      >
        {/* ROPES + TITLE */}
        <div className="relative flex justify-center items-center w-full">
          {/* Left Rope */}
          <img
            src={ROPE_LEFT}
            alt="Rope Left"
            className="
              relative
              transform
              w-16
              lg:w-32
              translate-y-1/4
              h-auto
            "
          />
          {/* Title */}
          <h2
            className="
              font-charles
              text-maroon
              text-5xl
              lg:text-6xl
              xl:text-7xl
              px-10
            "
          >
            {title}
          </h2>
          {/* Right Rope */}
          <img
            src={ROPE_RIGHT}
            alt="Rope Right"
            className="
              relative
              transform
              translate-y-1/4
              w-16
              lg:w-32
              h-auto
            "
          />
        </div>

        {/* Body Text */}
        <p
          className="
            font-prosto
            text-sea
            text-base
            sm:text-lg
            md:text-xl
            leading-relaxed
            max-w-xs
            lg:max-w-md
          "
        >
          {body}
        </p>
      </div>
    </div>
  );
};

export default RopeQuote;
